import React, { useEffect, useState, useContext, useRef } from "react";

import LoadingContext from "../../context/Loading/Loading";

import { getSinglarOrPluralWord } from "../../utilities/helpers";

import { searchEvents } from "../../utilities/api";

import Button from "react-bootstrap/Button";

import { SearchList } from "../SearchList";
import { PageLoadingContainer } from "../PageLoadingContainer";

// page
export default function SearchWrapper({ query }) {
  const { isLoading, showLoading, hideLoading } = useContext(LoadingContext);
  const lastRequestedQueryRef = useRef(null);

  // api is called with limited results
  const [results, setResults] = useState();

  useEffect(() => {
    const q = typeof query === "string" ? query.trim() : "";
    if (!q) {
      lastRequestedQueryRef.current = null;
      setResults([]);
      hideLoading();
      return;
    }

    if (lastRequestedQueryRef.current === q) {
      return;
    }

    lastRequestedQueryRef.current = q;

    let isCancelled = false;
    showLoading();
    let data = {
      data: q,
    };
    searchEvents(data)
      .then((res) => {
        if (isCancelled) return;
        setResults(res.data);
        hideLoading();
      })
      .catch((err) => {
        if (isCancelled) return;
        console.error(err);
        hideLoading();
      });

    return () => {
      isCancelled = true;
    };
  }, [query]);

  return (
    <>
      {isLoading ? (
        <PageLoadingContainer />
      ) : (
        <>
          {!query?.trim() ? (
            <h1 className="fs-md mb-5">
              Search for events using the bar above.
            </h1>
          ) : (
            <h1 className="fs-md mb-5">
              We found {results?.length}{" "}
              {results?.length > 0
                ? getSinglarOrPluralWord(results?.length, "result")
                : "results"}{" "}
              for &quot;{query.trim()}&quot;
            </h1>
          )}
          <SearchList queryResults={results} />
          {/* <Button variant="outline-light" className="mt-4">
                        Load more
                    </Button> */}
        </>
      )}
    </>
  );
}
